module.exports = __webpack_public_path__ + "img/visa.abc01b36.svg";